module.exports = __webpack_public_path__ + "static/media/ex-contact.de31d6a3.jpg";